
import React, { useState, useEffect } from "react";
import "./OurExperts.css";

const OurExperts = () => {
  const images = [
    // First Slide - First 5 Experts
    // {
    //   default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Animesh%20Jeswani.jpg",
    //   hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
    //   heading: "Animesh Jeswani",
    //   subheading: "Global Head of Tourism, BBT",
    //   text: "Animesh Jeswani brings a wealth of experience in travel consultancy, ensuring seamless travel solutions for clients worldwide. As a key expert in our team, he provides valuable insights into evolving travel trends, helping customers navigate their journeys with ease.",
    //   designation: " ",
    // },
    {
      default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Gaurav%20Makheeja.jpg",
      hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
      heading: "Gaurav Makheeja",
      subheading: "Global Head of Tourism, BBT",
      text: "As the expert managing Blueberry Algeria, Gaurav Makheeja is committed to providing smooth and efficient travel experiences. His knowledge of international regulations and local insights helps travelers make the most of their journeys.",
      designation: "Regional Manager",
    },
    // {
    //   default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Jiten%20Tolani.jpg",
    //   hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
    //   heading: "Jiten Tolani",
    //   subheading: "Global Head of Tourism, BBT",
    //   text: "With extensive experience in the travel industry, Jiten Tolani plays a crucial role in ensuring that travelers receive expert guidance. He is dedicated to delivering seamless travel solutions that prioritize customer comfort and convenience.",
    //   designation: "Lead Consultant",
    // },
    {
      default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Jitendra%20Asrani.jpg",
      hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
      heading: "Jitendra Asrani",
      subheading: "Global Head of Tourism, BBT",
      text: "Leading our Blueberry Zimbabwe branch, Jitendra Asrani ensures that travelers enjoy hassle-free and well-planned journeys. His expertise in handling diverse travel requirements makes him a trusted advisor for those traveling to and from Zimbabwe.",
      designation: "Regional Manager ",
    },
    // {
    //   default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Kishor%20Vatvani.jpg",
    //   hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
    //   heading: "Kishor Vatvani",
    //   subheading: "Global Head of Tourism, BBT",
    //   text: "Lorem ipsum dolor sit amet consectetur adipiscing elit...",
    //   designation: "Senior Developer",
    // },

    // Second Slide - Next 5 Experts
    {
      default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Lucky%20Jeswani.jpg",
      hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
      heading: "Lucky Jeswani",
      subheading: "Marketing Head, BBT",
      text: "As the head of Blueberry Madagascar, Lucky Jeswani is dedicated to making travel planning effortless. His deep industry knowledge enables him to provide clients with top-tier services, ensuring a smooth and enjoyable journey.",
      designation: "Country Manager",
    },
    {
      default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Manoj%20Adwani.jpg",
      hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
      heading: "Manoj Adwani",
      subheading: "Software Engineer, BBT",
      text: "With a strong understanding of global travel trends, Manoj Adwani ensures that every traveler receives personalized guidance. His expertise helps clients experience well-organized and efficient travel planning.",
      designation: "Regional Manager",
    },
    {
      default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Manoj%20Kumar.jpg",
      hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
      heading: "Manoj Kumar",
      subheading: "Finance Manager, BBT",
      text: "Overseeing our Blueberry Senegal branch, Manoj Kumar specializes in creating seamless travel experiences. His deep knowledge of the travel sector allows him to offer expert advice, making every trip well-planned and efficient.",
      designation: "Area Manager - Senegal Region",
    },
    {
      default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Nikhil%20Golani.jpg",
      hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
      heading: "Nikhil Golani",
      subheading: "Operations Manager, BBT",
      text: "As a key expert managing Blueberry Angola, Nikhil Golani is passionate about optimizing travel experiences. His in-depth understanding of international travel regulations ensures clients receive seamless and stress-free services.",
      designation: "Regional Manager",
    },
    {
      default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Prakash%20Lalwani.jpg",
      hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
      heading: "Prakash Lalwani",
      subheading: "HR Head, BBT",
      text: "Prakash Lalwani is committed to providing expert travel insights and solutions. His industry experience helps travelers navigate various travel requirements, ensuring smooth and well-coordinated journeys.",
      designation: "Regional Manager",
    },
    // third Slide - Next 5 Experts
    {
      default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Punit%20Manmani.jpg",
      hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
      heading: "Punit Manmani",
      subheading: "Marketing Head, BBT",
      text: "Leading Blueberry Abidjan operations, Punit Manmani plays a crucial role in enhancing travel experiences. His ability to streamline processes and address travel concerns ensures clients have a worry-free journey.",
      designation: "Country  Manager",
    },
    {
      default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Rajesh%20Nankani.jpg",
      hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
      heading: "Rajesh Nankani",
      subheading: "Software Engineer, BBT",
      text: "As the head of Blueberry Tanzania, Rajesh Nankani provides expert travel solutions, ensuring a seamless journey for clients. His in-depth knowledge of the region and global travel trends makes him an invaluable guide.",
      designation: "Country Manager",
    },
    // {
    //   default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Ravi%20Manghnani.jpg",
    //   hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
    //   heading: "Ravi Manghnani",
    //   subheading: "Finance Manager, BBT",
    //   text: " ",
    //      designation: "",
    // },
    {
      default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Ravi%20Sadhnani.jpg",
      hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
      heading: "Ravi Sadhnani",
      subheading: "Operations Manager, BBT",
      text: "Managing Blueberry Kinshasa, Ravi Sadhnani is known for his expertise in travel consultancy. His strategic approach ensures that travelers receive the best solutions for their trips, making every journey smooth and efficient.",
      designation: "Regional Manager",
    },
    // {
    //   default: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/RM%20CM/Yash%20Wadhwani.jpg",
    //   hover: "https://blueberrydatastorage.blob.core.windows.net/bbt/images/back-expert.png",
    //   heading: "Yash Wadhwani",
    //   subheading: "HR Head, BBT",
    //   text: "Passionate about employee engagement and organizational development.",
    //   designation: "HR Specialist",
    // },
  ];

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [selectedCardIndex, setSelectedCardIndex] = useState(null);
  const [slidesPerView, setSlidesPerView] = useState(5);

  // const handleCardClick = (index) => {
  //     setSelectedCardIndex((prevIndex) => (prevIndex === index ? null : index));
  // };
//   const handleCardClick = (index) => {
//     if (window.innerWidth > 576) { // Only allow click effect on desktop/tablet
//         setSelectedCardIndex((prevIndex) => (prevIndex === index ? null : index));
//     }
// };
  // Update slides per view based on window width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 576) {
        setSlidesPerView(1); // Mobile: 1 image per slide
      } else if (window.innerWidth <= 991) {
        setSlidesPerView(2); // Tablet: 2 images per slide
      } else if (window.innerWidth <= 1180) {
        setSlidesPerView(3); // Tablet: 2 images per slide
      } else {
        setSlidesPerView(5); // Desktop: 5 images per slide
      }
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Function to split images into groups of 5 per slide
  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, Math.min(i + size, arr.length)));
    }
    return chunks;
  };
  const handleMouseEnter = (index) => {
    if (window.innerWidth > 576) { // Disable hover effect on mobile
        setHoveredIndex(index);
    }
};


const handleMouseLeave = () => {
    if (window.innerWidth > 576) { // Disable hover effect on mobile
        setHoveredIndex(null);
    }
};

const handleCardClick = (index) => {
    if (window.innerWidth > 576) { // Disable click effect on mobile
        setSelectedCardIndex((prevIndex) => (prevIndex === index ? null : index));
    }
};


  const slides = chunkArray(images, slidesPerView);

  return (
    <div className="our-expert">
      <div className="mainSliderContainerOurExpert">
        <h1 className="headings text-center expert-h1 text-dark">
          <span>Meet</span> Our Experts
        </h1>
      </div>

      <div
        id="carouselExampleIndicators1"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#carouselExampleIndicators1"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-label={`Slide ${index + 1}`}
            ></button>
          ))}
        </div>

        <div className="carousel-inner">
          {slides.map((slide, slideIndex) => (
            <div
              key={slideIndex}
              className={`carousel-item ${slideIndex === 0 ? "active" : ""}`}
            >
              <div className="mainSliderContainerOurExpert">
                <div className="our-expert-section mt-3">
                  <div className="slider-container my-2">
                    {slide.map((img, index) => (
                      <div
                        key={index}
                        className="image-div"
                        style={{
                          backgroundImage: `url(${(hoveredIndex === index || (selectedCardIndex === index && window.innerWidth > 576)) ? img.hover : img.default})`,
                        }}
                        onMouseEnter={() => handleMouseEnter(index)}
                        onMouseLeave={handleMouseLeave}
                        onClick={() => handleCardClick(index)}
                      >
                        {hoveredIndex !== index && selectedCardIndex !== index && (
                          <div className="image-overlayText">
                            <h4 className="fw-bold">{img.heading}</h4>
                            <p className="txt-overlay-p">{img.designation}</p>
                          </div>
                        )}
                        {(hoveredIndex === index || selectedCardIndex === index) && (
                          <div className="ourExpertContent">
                            <h2>{img.heading}</h2>
                            <h5 className="subhead-txt1">{img.subheading}</h5>
                            <p>{img.text}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <button
          className="carousel-control-prev dark-button"
          type="button"
          data-bs-target="#carouselExampleIndicators1"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon me-4 me-md-5" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>

        <button
          className="carousel-control-next dark-button"
          type="button"
          data-bs-target="#carouselExampleIndicators1"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon ms-4 ms-md-5" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default OurExperts;


